<template>
<div>
    <Partners v-if="route == '/employer/partners'"></Partners>
    <AddPartner v-if="route == '/employer/partners/add-new'"></AddPartner>
    <Result v-if="route == '/employer/partners/add-new/result'"></Result>
    <InvitePartner v-if="route == '/employer/partners/invite-partner'"></InvitePartner>
    <Partner v-if="route == '/employer/partners/partner'"></Partner>

</div>

</template>
<script>
import Partners from './PartnersTable.vue'
import AddPartner from './AddPartner.vue'
import InvitePartner from './InvitePartner.vue'
import Partner from './Partner.vue'
import Result from './Result.vue'

export default{
    components:{
        Partners,
        AddPartner,
        InvitePartner,
        Partner,
        Result
    },
    computed:{
        route(){
            return this.$route.path
        }
    }
}
</script>